var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAutomatischAngefragt)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"d-inline-flex align-items-center",attrs:{"title":"Ticket automatisch angefragt"}},[_c('Bot',{attrs:{"size":20}})],1):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }